import Vue from 'vue'

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

import 'vue-resize/dist/vue-resize.css'
import _ from 'lodash'
import App from './App.vue'
import Vuex from 'vuex'

import VueResize from 'vue-resize'
Vue.use(VueResize)

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);


import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
});


import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "" },
  params: {
    send_page_view: false
  },
  enabled:false
});


Vue.config.productionTip = false



import VueRouter from 'vue-router'
Vue.use(VueRouter)


const routes = [
  /* { path: '/blank', component: frmBlank }, */

];

const router = new VueRouter({
  mode: 'history',
  routes, // short for `routes: routes`
  scrollBehavior() {
    return {x: 0, y: 0}
  }  
})

router.beforeEach((to, from, next) => {

  /*
  console.log("rt from:");
  console.log(from);
  console.log("rt to:");
  console.log(to);
  */

  grcmain_SetBodyScrollable(true);

  if (gMegaMenuVisible || gUserMenuVisible)
  {
    //CloseMegaMenu();
    CloseTopMenus();
    next(false);
    return;
  }
  
  if ((gForm != null)&&(gPopupControlName != ""))
  {
    ClosePopup(gPopupControlName);
    next(false);
    return;
  }
  
  
  gForm = null;
  gPopupControlName = "";
  gCMS_PageAlias = to;

  next();
  
})

router.afterEach((to, from) => {

})

var app = new Vue({
  render: h => h(App),
  router
}).$mount('#app')



